import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/miseventos/:codi_modalidad',
    name: 'MisEventos',
    component: () => import('../views/MisEventosView.vue'),
  },
  {
    path: '/evento/:codi_modalidad/:codi_evento',
    name: 'Evento',
    component: () => import('../views/EventoView.vue'),
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: () => import('../views/PerfilView.vue'),
  },
  {
    path: '/RecuperacionContrasena',
    name: 'RecuperacionContrasena',
    component: () => import('../views/RecuperacionContrasenaView.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
